export const imageTags = [
  "nature",
  "sunset",
  "beach",
  "mountains",
  "forest",
  "cityscape",
  "portrait",
  "wildlife",

];

export const statusOptions = [
  { value: "Inactive", label: "Inactive", color: "orange" },
  { value: "Created", label: "Created", color: "grey" },
  { value: "Active", label: "Active", color: "#6EC531" },
  { value: "Blocked", label: "Blocked", color: "red" },
];




export const groupData = [
  {"value": 1, "label": " KS2 Lower"},
  {"value": 2, "label": "KS2 Higher"},
  { "value": 3, "label": "KS3" },
  { "value": 4, "label": "KS4" },
  { "value": 14, "label": "College"},
  { "value": 18 , "label":"Post - 18"},
  { "value": "all", "label": "All Key Stages"},
  { "value": 16, "label": "All Key Stages" },
  // { "value": 5, "label": "KS5" },
  // {"id": 6, "name": "Six"},
  // {"id": 7, "name": "Seven"},
  // {"id": 8, "name": "Eight"},
  // {"id": 9, "name": "Nine"},
  // {"id": 10, "name": "Ten"},
  // {"id": 11, "name": "Eleven"},
  // {"id": 12, "name": "Twelve"}
]

export const groupYearData = [
  {"value": 1, "label": " KS2 Lower"},
  {"value": 2, "label": "KS2 Higher"},
  { "value": 3, "label": "KS3" },
  { "value": 4, "label": "KS4" },
  { "value": 14, "label": "College" },
  {"value":18 ,"label":"Post - 18"}
]


export const specificUser = [
  { "value": "Student", "label": "Student" },
  { "value": "Parent", "label": "Parent" },
]




export const GENDER_TYPE=[

  { "value": "Male", "label": "MALE" },
  { "value": "Female", "label": "FEMALE" },
  { "value": "Other", "label": "OTHER" },
  { "value": "Prefer not to say", "label": "PREFER" },
]




export const groupDataStudent = [
  // {"id": 1, "name": "One"},
  // {"id": 2, "name": "Two"},
  { "value": 3, "label": "KS3" },
  { "value": 4, "label": "KS4" },
  { "value": "All", "label": "All" },
  // {"id": 6, "name": "Six"},
  // {"id": 7, "name": "Seven"},
  // {"id": 8, "name": "Eight"},
  // {"id": 9, "name": "Nine"},
  // {"id": 10, "name": "Ten"},
  // {"id": 11, "name": "Eleven"},
  // {"id": 12, "name": "Twelve"}
]

export const SchoolTypeData = [
  { "value": "School/College/Organisation", "label": "School/College/Organisation" },
  { "value": "Sponsor", "label": "Sponsor" },
  { "value": "Seller", "label": "Seller" }
];





export const sensitiveDataTypes = [
  { value: "Suicide", label: "Suicide" },
  { value: "Eating disorders", label: "Eating disorders" },
  { value: "Self-harm or body hatred", label: "Self-harm or body hatred" },
  { value: "Addiction", label: "Addiction" },
  { value: "Gender dysphoria involving body hatred or self-harm", label: "Gender dysphoria involving body hatred or self-harm" },
  { value: "Sexual harassment", label: "Sexual harassment" },

 

  { value: "Abuse", label: "Abuse" },
  { value: "Rape", label: "Rape" },
  { value: "Severe or graphic violence", label: "Severe or graphic violence" },
  { value: "Murder or genocide", label: "Murder or genocide" },
  { value: "Child abuse, paedophilia, incest or child death", label: "Child abuse, paedophilia, incest or child death" },
  { value: "Incest", label: "Incest" },
  { value: "Paedophilia", label: "Paedophilia" },
  { value: "Child death", label: "Child death" },





  { value: "Abduction or kidnapping", label: "Abduction or kidnapping" },
  { value: "Human trafficking or forced prostitution", label: "Human trafficking or forced prostitution" },
  { value: "Racism or hate speech", label: "Racism or hate speech" },
  { value: "Stillbirth, miscarriage or traumatic childbirth", label: "Stillbirth, miscarriage or traumatic childbirth" },
  { value: "Colonialism, slavery and intergenerational trauma", label: "Colonialism, slavery and intergenerational trauma" },
  { value: "Severe mental distress or illness, psychosis or trauma", label: "Severe mental distress or illness, psychosis or trauma" },
  { value: "Severe debt", label: "Severe debt" },
  { value: "Animal cruelty", label: "Animal cruelty" },



  { value: "Death or severe illness", label: "Death or severe illness" },
  { value: "Mental illness", label: "Mental illness" },
  { value: "Divorce or family separation", label: "Divorce or family separation" },
  { value: "Common phobias - Spiders", label: "Common phobias - Spiders" },
  { value: "Common phobias - Snakes", label: "Common phobias - Snakes" },


  { value: "Common phobias - Needles", label: "Common phobias - Needles" },
  { value: "Gender dysphoria not involving body hatred or self-harm", label: "Gender dysphoria not involving body hatred or self-harm" },
  { value: "Disordered Eating", label: "Disordered Eating" },
  { value: "Death", label: "Death" },
  { value: "Violence", label: "Violence" },
  { value: "Drugs", label: "Drugs" }


];

export const dropdownGroupsDashboard = [
  {
    group: 1,
    label: "KS2 Lower",
    years: [
      { value: 3, name: "3" },
      { value: 4, name: "4" },
    ],
  },
  {
    group: 2,
    label: "KS2 Higher",
    years: [
      { value: 5, name: "5" },
      { value: 6, name: "6" },
    ],
  },
  {
    group: 3,
    label: "KS3",
    years: [
      { value: 7, name: "7" },
      { value: 8, name: "8" },
      { value: 9, name: "9" },
    ],
  },
  {
    group: 4,
    label: "KS4",
    years: [
      { value: 10, name: "10" },
      { value: 11, name: "11" },
    ],
  },
  {
    group: 14,
    label: "College",
    years: [{ value: 14, name: "14" }],
  },
  {
    group: 18,
    label: "Post - 18",
    years: [{ value: 18, name: "18" }],
  }
];